import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useBrand } from '@atc/brand';
import { useFeatures } from '@atc/features';

import { sendImpressions } from 'reaxl-analytics';
import {
    InventoryListingV2,
} from 'reaxl-listing';

import configureListingTiles from '@/utilities/configureListingTiles';
import useInventoryListingProps from '@/utilities/useInventoryListingProps';

import { supplementalImpressions } from '@/analytics/srpAnalyticsHandlers';

import { cpoContentDuck } from '@/ducks';

import { srpFiltersDuck, srpSupplementalDuck } from '@/ducks/srp';

const InventorySupplementalResultsContainer = ({
    endIndex,
    startIndex,
}) => {
    const { brand } = useBrand();

    const {
        override_carfax_tile: [isOverrideCarfaxTileEnabled, { partner }],
        remove_carfax_tile: [removeCarfaxTile],
        remove_experian_tile: [removeExperianTile],
    } = useFeatures([
        'override_carfax_tile',
        'remove_carfax_tile',
        'remove_experian_tile',
    ]);

    const dispatch = useDispatch();

    const listingsChunk = useSelector((state) => (srpSupplementalDuck.selectors.getActiveInventory(state) || []).slice(startIndex, endIndex));

    const certifiedSponsor = useSelector(cpoContentDuck.selectors.selectCertifiedContentSimple);
    const searchRadius = useSelector(srpFiltersDuck.selectors.getSelectedSearchRadius);

    const supplementalListingsSet = configureListingTiles({
        brand,
        certifiedSponsor,
        items: listingsChunk,
        isOverrideCarfaxTileEnabled,
        partner,
        tier: 'supplemental',
        removeCarfaxTile,
        removeExperianTile,
    });

    const getListingProps = useInventoryListingProps();

    useEffect(() => {
        dispatch(srpSupplementalDuck.creators.setLoadedCount(endIndex));

        const listingIds = [];
        supplementalListingsSet.forEach((listing) => {
            listingIds.push(listing?.id);
        });

        sendImpressions({
            data: {
                rank: startIndex + 1,
                selectedItemIds: listingIds,
            },
            name: supplementalImpressions,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return supplementalListingsSet.map((listing, index) => {
        listing.isSupplemental = true;
        listing.searchRadius = searchRadius;
        return (
            <React.Fragment key={`suppl_${listing.id}`}>
                <div
                    className="col-xs-12 col-sm-4 display-flex"
                >
                    <InventoryListingV2
                        data-cmp="supplementalListing"
                        {...getListingProps('supplemental', listing, index)}
                    />
                </div>
            </React.Fragment>
        );
    });
};

export default InventorySupplementalResultsContainer;
